function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RegisterStep.css';
import React, { useState, useEffect } from 'react';
import Password from './components/Password';
import FormField from './components/FormField';
import Checkboxes from './components/Checkboxes';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { loaderToggle } from '../../utils/setUserCookie';
import { canUseDOM, get } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { commonStyles, rtlStyles, ltrStyles } from './accountAuthorizationStyles';
import { validateRequired, runValidations, validatePassword, validateRequiredSelect, validateRequiredCheckbox, validateLengthButNotRequired, validateIsUnder18, validateMaxLength, validateAlphabetsOnly, validateMinLength } from './commomFunctions';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import SelectFieldCustom from './components/SelectFieldCustom';
import PhoneWithCountrySelection from './components/PhoneWithCountrySelection';
import DateField from './components/DateField';
import { STEPS } from './AccountAuthorization';
const AGE_LIMIT = '18';
const defaultMaxLength = 15;
const defaultMinLength = 9;
const NAME_MIN_LENGTH = 2;
const NAME_MAX_LENGTH = 50;
const RegisterStep = _ref => {
  let {
    fields,
    params,
    userEmail,
    getActiveStep,
    getRegisterData,
    setGlobalLoader,
    registerData,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const currentLang = get(sitecoreContext, 'language');
  const registerFormFill = get(fields, 'data.registerFormFill');
  const registerFormPrivacy = get(fields, 'data.registerFormPrivacy');
  const createAccountPrivacyConsent = get(fields, 'data.datasource.createAccountPrivacyConsent.jss.value');
  const SubmitBtnText = mapDictionary.get('Register');
  const labelfname = mapDictionary.get('FirstName');
  const labellname = mapDictionary.get('LastName');
  const labelPass = mapDictionary.get('Password');
  const labelConfirmPass = mapDictionary.get('ConfirmPassword');
  const labelCountry = mapDictionary.get('Country');
  const labelEmailMarketing = mapDictionary.get('ReceiveOffers');
  const privacyPolicyMessage = mapDictionary.get('PrivacyNotice');
  const privacyPolicyMessageLinkText = mapDictionary.get('Privacy policy link text');
  const privacyPolicyMessageLink = get(fields, 'data.contextItem.privacyNoticeLink.jss.value.href');
  const errorRequiredFname = mapDictionary.get('error required firstname');
  const errorFormatFname = mapDictionary.get('error format firstname');
  const errorMaxLengthFname = mapDictionary.get('error maxlength firstname');
  const errorRequiredLname = mapDictionary.get('error required lastname');
  const errorFormatLname = mapDictionary.get('error format lastname');
  const errorMaxLengthLname = mapDictionary.get('error maxlength lastname');
  const errorRequiredPassword = mapDictionary.get('error required password');
  const errorFormatPassword = mapDictionary.get('error format password');
  const tooltipPassword = mapDictionary.get('tooltipPassword');
  const dateOfBirthTooltip = mapDictionary.get('dateOfBirthTooltip');
  const errorMinLengthLname = mapDictionary.get('error minlength firstname');
  const errorMinLengthFname = mapDictionary.get('error minlength lastname');
  const errorRequiredConfirmPassword = mapDictionary.get('error requi-red confirm pass');
  const errorMatchConfirmPassword = mapDictionary.get('error must match password');
  const errorRequiredCountry = mapDictionary.get('error required country');
  const ageIsNotValid = mapDictionary.get('ageValidationMessage') || '';
  const dateOfBirthLabel = mapDictionary.get('dateOfBirthLabel');
  const whatsAppLabel = mapDictionary.get('whatsAppLabel');
  const whatsAppPlaceholder = mapDictionary.get('whatsAppPlaceholder');
  const whatsAppTooltip = mapDictionary.get('ReceiveUpdatesViaWhatsApp');
  const nationalityLabel = mapDictionary.get('nationalityLabel');
  const errorMinLengthWhatsAppNumber = mapDictionary.get('errorMinLengthWhatsAppNumber');
  const errorMaxLengthWhatsAppNumber = mapDictionary.get('errorMaxLengthWhatsAppNumber');
  const errorRequiredNationality = mapDictionary.get('errorRequiredNationality');
  const errorRequiredDateOfBirth = mapDictionary.get('errorRequiredDateOfBirth');
  const errorRequiredAccountPrivacyConsent = mapDictionary.get('FieldErrorRequiredAccountPrivacyConsent');
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const [disableSubmit, setDisableSubmit] = useState(true);
  let allErrors = [];
  const [formResponseError, setFormResponseError] = useState('');
  const hasCountries = Boolean(get(fields, 'data.countries.countryValues.length'));
  const countriesList = hasCountries ? get(fields, 'data.countries.countryValues') : [];
  const hasNationalities = Boolean(get(fields, 'data.nationality.countryValues.length'));
  const nationalityList = hasNationalities ? get(fields, 'data.nationality.countryValues') : [];
  let currentCountry;
  if (canUseDOM) {
    currentCountry = get(window, 'utag_data.session_country_code') || '-1';
  }
  const countryOptions = Object.assign(countriesList).map(country => {
    const countryName = get(country, 'countryName.jss.value');
    const countryCode = get(country, 'countryCode.jss.value');
    return {
      value: countryCode,
      label: countryName
    };
  });
  const nationalityOptions = Object.assign(nationalityList).map(nationality => {
    const itemName = get(nationality, 'itemName');
    const title = get(nationality, 'title.jss.value');
    return {
      value: itemName,
      label: title
    };
  });
  const phoneCodesOptions = Object.assign(countriesList).map(phone => {
    const phoneCode = get(phone, 'phoneCode.jss.value');
    return {
      value: phoneCode,
      label: phoneCode
    };
  });
  const countriesForPhoneOptions = Object.assign(countriesList).map(country => {
    const countryName = get(country, 'countryName.jss.value');
    const countryCode = get(country, 'countryCode.jss.value');
    const flag = get(country, 'flag.jss.value');
    const flagSrc = get(flag, 'src');
    const phoneCode = get(country, 'phoneCode.jss.value');
    return {
      code: countryCode,
      flag,
      flagSrc,
      text: phoneCode,
      value: phoneCode,
      countryName
    };
  });
  const validateMatchPasswordChild = (value, fieldObj) => {
    if (value === fieldPassword) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorMatchChild);
      return false;
    }
  };
  const validateMatchPasswordParent = (value, fieldObj) => {
    if (value === fieldConfirmPassword) {
      setErrorConfirmPassword('');
      return true;
    } else {
      setErrorConfirmPassword(errorMatchConfirmPassword);
      return false;
    }
  };

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    for (const fieldObj of allErrors) {
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };
  React.useEffect(() => {
    if (registerData) {
      setFirstname(registerData.FirstName || '');
      setLastname(registerData.LastName || '');
      setFieldPassword(registerData.Password || '');
      setFieldConfirmPassword(registerData.ConfirmPassword || '');
      seWhatsappNumber(registerData.phoneNumber || '');
      setDateOfBirth(registerData.birthDate || '');
      setCountry(registerData.country || '-1');
      setNationality(registerData.nationality || '-1');
      setCheckboxes([{
        name: 'email-marketing',
        id: 'email-marketing',
        value: registerData.MarketingCommmunicationCheck || false,
        label: labelEmailMarketing
      }]);
      setConsent([{
        name: 'consent',
        id: 'consent',
        value: registerData.consentChexbox || false,
        childrenHTML: /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: createAccountPrivacyConsent
          }
        }),
        errorRequired: errorRequiredAccountPrivacyConsent,
        isRequired: true
      }]);
    }
  }, []);

  // Form submit handler
  const formSubmit = event => {
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      getActiveStep(STEPS.STEP3);
      getRefisterUserData();
    }
    event.preventDefault();
  };
  const getRefisterUserData = () => {
    const userData = {
      ClientId: clientId,
      FirstName: firstname,
      LastName: lastname,
      Email: userEmail,
      Password: fieldPassword,
      ConfirmPassword: fieldConfirmPassword,
      birthDate: dateOfBirth,
      MarketingCommmunicationCheck: checkboxes[0].value,
      consentChexbox: consent[0].value,
      ContextLanguage: currentLang,
      country: country,
      phoneNumber: whatsappNumber,
      nationality: nationality
    };
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), SubmitBtnText);
    getRegisterData(_objectSpread(_objectSpread({}, registerData), userData));
  };

  // First script field start

  const [firstname, setFirstname] = useState('');
  const [errorFirstName, setErrorFirstName] = useState('');
  const formFillAnalytics = () => tealiumClickFunc(tealiumMergeClickData(registerFormFill, params));
  const firstnameId = `register_${mapDictionary.get('Firstname') || 'Firstname'}`;
  const firstNameFieldProps = {
    value: firstname,
    fieldError: errorFirstName,
    setError: setErrorFirstName,
    label: labelfname,
    type: 'text',
    id: firstnameId,
    name: firstnameId,
    labelLight: false,
    maxLength: NAME_MAX_LENGTH,
    minLength: NAME_MIN_LENGTH,
    errorRequired: errorRequiredFname,
    errorValue: errorFormatFname,
    errorMaxLength: errorMaxLengthFname,
    errorMinLength: errorMinLengthFname,
    autoComplete: firstnameId,
    required: true,
    changeEvent: value => {
      setFirstname(value);
    },
    blurEvent: value => {
      firstNameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : firstname;
      return runValidations([validateRequired, validateAlphabetsOnly, validateMinLength, validateMaxLength], value, firstNameFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(firstNameFieldProps);

  // First name field end
  // Last name field start

  const [lastname, setLastname] = useState('');
  const [errorLastName, setErrorLastName] = useState('');
  const lastnameId = `register_${mapDictionary.get('Lastname') || 'Lastname'}`;
  const lastNameFieldProps = {
    value: lastname,
    fieldError: errorLastName,
    setError: setErrorLastName,
    label: labellname,
    type: 'text',
    id: lastnameId,
    name: lastnameId,
    labelLight: false,
    maxLength: NAME_MAX_LENGTH,
    minLength: NAME_MIN_LENGTH,
    errorRequired: errorRequiredLname,
    errorValue: errorFormatLname,
    errorMaxLength: errorMaxLengthLname,
    errorMinLength: errorMinLengthLname,
    autoComplete: lastnameId,
    required: true,
    changeEvent: value => {
      setLastname(value);
    },
    blurEvent: value => {
      lastNameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastname;
      return runValidations([validateRequired, validateAlphabetsOnly, validateMinLength, validateMaxLength], value, lastNameFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(lastNameFieldProps);

  // Last name field end
  // Password Field Start

  const [fieldPassword, setFieldPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const passwordId = `register_${mapDictionary.get('Password') || 'Password'}`;
  const passwordFieldProps = {
    value: fieldPassword,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: labelPass,
    type: 'password',
    id: passwordId,
    name: passwordId,
    labelLight: false,
    passLink: null,
    isTooltip: true,
    errorRequired: errorRequiredPassword,
    errorValue: errorFormatPassword,
    tooltip: tooltipPassword,
    required: true,
    autoComplete: 'off',
    changeEvent: value => {
      setFieldPassword(value);
    },
    blurEvent: value => {
      passwordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fieldPassword;
      return runValidations([validateRequired, validatePassword, validateMatchPasswordParent], value, passwordFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(passwordFieldProps);

  // Password Field End
  // Confirm Pass Field Start

  const [fieldConfirmPassword, setFieldConfirmPassword] = useState('');
  const [errorConfirmPassword, setErrorConfirmPassword] = useState('');
  const fieldConfirmPasswordId = `register_${mapDictionary.get('ConfirmPassword') || 'ConfirmPassword'}`;
  const confirmPasswordFieldProps = {
    value: fieldConfirmPassword,
    fieldError: errorConfirmPassword,
    setError: setErrorConfirmPassword,
    label: labelConfirmPass,
    type: 'password',
    id: fieldConfirmPasswordId,
    name: fieldConfirmPasswordId,
    labelLight: false,
    passLink: null,
    errorRequired: errorRequiredConfirmPassword,
    errorMatchChild: errorMatchConfirmPassword,
    required: true,
    autoComplete: 'off',
    changeEvent: value => {
      setFieldConfirmPassword(value);
    },
    blurEvent: value => {
      confirmPasswordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fieldConfirmPassword;
      return runValidations([validateRequired, validateMatchPasswordChild], value, confirmPasswordFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(confirmPasswordFieldProps);

  // Confirm Password Field End

  // Phone field start

  const [whatsappNumber, seWhatsappNumber] = useState('');
  const [errorWhatsappNumber, setErrorWhatsappNumber] = useState('');
  const whatsappNumberFieldProps = {
    value: whatsappNumber,
    fieldError: errorWhatsappNumber,
    setError: setErrorWhatsappNumber,
    label: whatsAppLabel,
    type: 'text',
    id: whatsAppLabel,
    name: whatsAppLabel,
    tooltip: whatsAppTooltip,
    placeholder: whatsAppPlaceholder,
    labelLight: false,
    maxLength: defaultMaxLength,
    minLength: defaultMinLength,
    errorMaxLength: errorMaxLengthWhatsAppNumber,
    errorMinLength: errorMinLengthWhatsAppNumber,
    autoComplete: 'whatsapp',
    required: false,
    changeEvent: value => {
      seWhatsappNumber(value);
    },
    blurEvent: value => {
      whatsappNumberFieldProps.validate();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : whatsappNumber;
      const [countryCode, phoneNumber] = value.split('|');
      return runValidations([validateLengthButNotRequired], phoneNumber, whatsappNumberFieldProps);
    },
    // focusEvent: formFillAnalytics,
    countryItems: countriesForPhoneOptions,
    options: phoneCodesOptions
  };
  allErrors.push(whatsappNumberFieldProps);

  // Phone field end

  // dateOfBirth field start

  const [dateOfBirth, setDateOfBirth] = useState('');
  const [errorDateOfBirth, setErrorDateOfBirth] = useState('');
  const dateOfBirthFieldProps = {
    value: dateOfBirth,
    name: 'RegisterDateOfBirth',
    label: dateOfBirthLabel,
    patternInvalidMessage: ageIsNotValid,
    setError: setErrorDateOfBirth,
    required: false,
    isValid: Boolean(errorDateOfBirth),
    ageLimit: AGE_LIMIT,
    errorRequired: errorRequiredDateOfBirth,
    isOnlyPast: true,
    minDate: new Date(new Date().getFullYear() - 100, new Date().getMonth(), new Date().getDate()),
    tooltip: dateOfBirthTooltip,
    isTooltip: true,
    updateContext: obj => {
      const val = obj.RegisterDateOfBirth.value;
      setDateOfBirth(val);
      dateOfBirthFieldProps.validate(val);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dateOfBirth;
      return runValidations([validateIsUnder18], value, dateOfBirthFieldProps);
    }
    // focusEvent: formFillAnalytics,
  };
  allErrors.push(dateOfBirthFieldProps);

  // dateOfBirth field end

  //  Country Field Start

  const [country, setCountry] = useState('-1');
  const [errorCountry, setErrorCountry] = useState('');
  const countryId = `register_${mapDictionary.get('Country') || 'Country'}`;
  const countryFieldProps = {
    value: country,
    fieldError: errorCountry,
    setError: setErrorCountry,
    label: labelCountry,
    id: countryId,
    name: countryId,
    labelLight: false,
    errorRequired: errorRequiredCountry,
    autoComplete: 'country-name',
    required: true,
    changeEvent: value => {
      setCountry(value);
      countryFieldProps.validate(value);
      // formFillAnalytics();
    },
    blurEvent: value => {
      countryFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : country;
      return runValidations([validateRequiredSelect], value, countryFieldProps);
    },
    options: countryOptions
  };
  allErrors.push(countryFieldProps);

  //  Country Field End

  //  Nationality Field Start

  const [nationality, setNationality] = useState('-1');
  const [errorNationality, setErrorNationality] = useState('');
  const nationalityFieldProps = {
    value: nationality,
    setError: setErrorNationality,
    label: nationalityLabel,
    fieldError: errorNationality,
    errorRequired: errorRequiredNationality,
    id: nationalityLabel,
    name: nationalityLabel,
    labelLight: false,
    autoComplete: 'nationality-name',
    required: true,
    changeEvent: value => {
      setNationality(value);
      nationalityFieldProps.validate(value);

      // formFillAnalytics();
    },
    blurEvent: value => {
      nationalityFieldProps.validate(value);
    },
    options: nationalityOptions,
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : nationality;
      return runValidations([validateRequiredSelect], value, nationalityFieldProps);
    }
  };
  allErrors.push(nationalityFieldProps);

  //  Nationality Field End
  //  Checkboxes Field Start
  const [checkboxes, setCheckboxes] = useState([{
    name: 'email-marketing',
    id: 'email-marketing',
    value: false,
    label: labelEmailMarketing
  }]);
  const [errorCheckboxes, setErrorCheckboxes] = useState('');
  const checkboxesFieldProps = {
    checkboxes: checkboxes,
    fieldError: errorCheckboxes,
    setError: setErrorCheckboxes,
    errorRequired: '',
    changeEvent: (name, value) => {
      let checkboxesCopy = checkboxes;
      checkboxesCopy = checkboxesCopy.filter(item => {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setCheckboxes(checkboxesCopy);
      checkboxesFieldProps.validate();
      // formFillAnalytics();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, checkboxesFieldProps);
    }
  };
  allErrors.push(checkboxesFieldProps);

  //  Checkboxes Field End

  //  consent Field Start
  const [consent, setConsent] = useState([{
    name: 'consent',
    id: 'consent',
    value: false,
    childrenHTML: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: createAccountPrivacyConsent
      }
    }),
    errorRequired: errorRequiredAccountPrivacyConsent,
    isRequired: true
  }]);
  const [errorConsent, setErrorConsent] = useState('');
  const consentFieldProps = {
    checkboxes: consent,
    fieldError: errorConsent,
    setError: setErrorConsent,
    errorRequired: errorRequiredAccountPrivacyConsent,
    changeEvent: (name, value) => {
      let checkboxesCopy = consent;
      checkboxesCopy = checkboxesCopy.filter(item => {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setConsent(checkboxesCopy);
      consentFieldProps.validate();
      // formFillAnalytics();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, consentFieldProps);
    }
  };
  allErrors.push(consentFieldProps);

  //  consent Field End

  useEffect(() => {
    const errorExist = errorFirstName || errorLastName || errorPassword || errorConfirmPassword || errorNationality || errorCountry || errorWhatsappNumber || errorConsent;
    const fieldsFilled = firstname && lastname && fieldPassword && fieldConfirmPassword && country && nationality && consent[0].value;
    if (errorExist) {
      setDisableSubmit(true);
    } else if (!fieldsFilled) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [errorFirstName, errorLastName, errorConfirmPassword, errorPassword, errorCountry, errorWhatsappNumber, firstname, lastname, fieldPassword, fieldConfirmPassword, country, nationality, consent[0].value, errorConsent]);
  if (!fields) {
    console.warn('Register component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[Register component is empty: please provide datasource]");
    }
    return null;
  }
  const RegistrationForm = /*#__PURE__*/React.createElement("div", {
    className: `lr ${rtl ? rtlStyles : ltrStyles} ${commonStyles} ${mainStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__form form-elements"
  }, /*#__PURE__*/React.createElement("form", {
    className: "w-100",
    onSubmit: event => formSubmit(event),
    noValidate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(FormField, firstNameFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(FormField, lastNameFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(Password, confirmPasswordFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(SelectFieldCustom, countryFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(SelectFieldCustom, nationalityFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(PhoneWithCountrySelection, whatsappNumberFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(DateField, dateOfBirthFieldProps))), /*#__PURE__*/React.createElement(Checkboxes, checkboxesFieldProps), /*#__PURE__*/React.createElement(Checkboxes, consentFieldProps), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "submit",
    disabled: disableSubmit
  }, SubmitBtnText), /*#__PURE__*/React.createElement("p", {
    className: "body-small privacy-policy"
  }, privacyPolicyMessage, ' ', /*#__PURE__*/React.createElement(RouterLink, {
    className: 'lr__link-color',
    onClick: () => {
      // tealiumClickFunc(tealiumMergeClickData(registerFormPrivacy, params));
    },
    href: privacyPolicyMessageLink
  }, privacyPolicyMessageLinkText)), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null)))));
  return RegistrationForm;
};
const mainStyles = "m195kdri";
export default RegisterStep;